import React from "react";

import { Article } from "./Layout";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinkIcon from "@mui/icons-material/Link";

import makeStyles from '@mui/styles/makeStyles';

import { Chart as ChartJs,
  Filler,
  Legend,
  LineController,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip
} from 'chart.js';
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-date-fns';
import annotationPlugin from 'chartjs-plugin-annotation';

import { generateChartData, chartOptions } from "./ChartTemplate";

ChartJs.register(
  Filler,
  Legend,
  LineController,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
  annotationPlugin
);

const chartStyles = makeStyles(theme => ({
  lineChart: {
    padding: theme.spacing(2)
  },
  selectModel: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  permalink: {
    textAlign: "center"
  }
}));

const Chart = props => {
  /* extract props */
  const { charttitle, modeldata, permalink } = props;

  const classes = chartStyles(props.theme);

  if (modeldata.length < 1) {
    return <div>Loading chart...</div>;
  }
  return (
    <Article header={charttitle}>
      <Grid item xs={12} className={classes.lineChart}>
        <Line data={generateChartData(modeldata)} options={chartOptions} />
      </Grid>
      <Grid item xs={1} className={classes.permalink}>
        <IconButton href={permalink} size="large">
          <LinkIcon />
        </IconButton>
        <Typography variant="caption">Permalink</Typography>
      </Grid>
    </Article>
  );
};

export default Chart;
